import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-blue-600 dark:text-blue-400">
            404
          </h1>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mt-4">
            {t("errors.pageNotFound")}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
        </div>

        <div className="space-y-4">
          <button
            onClick={() => navigate("/dashboard")}
            className="btn-primary w-full flex items-center justify-center space-x-2"
          >
            <Home className="h-4 w-4" />
            <span>{t("errors.goHome")}</span>
          </button>

          <button
            onClick={() => navigate(-1)}
            className="btn-secondary w-full flex items-center justify-center space-x-2"
          >
            <ArrowLeft className="h-4 w-4" />
            <span>{t("common.back")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

































